export const DEVICE_CATEGORY_LABELS = {
  client: "Windows client",
  server: "Server",
  mac: "Mac",
  linux: "Linux",
}

export const DEVICE_CATEGORY_OPTIONS = [
  { value: "client", label: "Windows clients" },
  { value: "server", label: "Servers" },
  { value: "mac", label: "Mac" },
  { value: "linux", label: "Linux" },
]

export const DEVICE_CATEGORY_COLORS = {
  client: "blue",
  server: "geekblue",
  mac: "default",
  linux: "orange",
}

export const deviceCategoryTitle = (category) => {
  const match = DEVICE_CATEGORY_OPTIONS.find((item) => item.value === category)
  return match?.label || ""
}

export const deviceCategoryOf = (device = {}) =>
  device.deviceCategory || ""

export const deviceCategoryLabelOf = (device = {}) =>
  device.deviceCategoryLabel ||
  DEVICE_CATEGORY_LABELS[deviceCategoryOf(device)] ||
  ""
